import { FormControl, FormField, FormItem, FormLabel } from "../ui/form";
import type { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { MultiSelectGenre } from "../ui/multi-select-genre";

type FormMultiSelectProps<T extends FieldValues> = {
	form: UseFormReturn<T>;
	name: Path<T>;
	label?: string;
	placeholder: string;
	options: {
		id: string;
		title: string;
		icon?: string;
	}[];
	fetcher?: () => Promise<void>;
	fetching?: boolean;
};

export const FormMultiSelectGenre = <T extends FieldValues>({
	form,
	name,
	label,
	placeholder,
	options,
	fetcher,
	fetching,
}: FormMultiSelectProps<T>) => {
	return (
		<FormField
			control={form.control}
			name={name}
			render={({ field }) => (
				<FormItem>
					<FormLabel className="flex items-center gap-1 font-semibold">
						{label}
					</FormLabel>
					<FormControl>
						<MultiSelectGenre
							fetcher={fetcher}
							fetching={fetching}
							className="py-6 pl-4 border border-border rounded-xl h-fit font-semibold placeholder:text-secondary resize-none"
							placeholder={placeholder}
							defaultValue={field.value ? field.value : []}
							{...field}
							options={[
								...options.map((option) => ({
									value: option.id,
									label: option.title,
									icon: option.icon,
								})),
							]}
							onValueChange={(e) => {
								field.onChange(e);
							}}
						/>
					</FormControl>
				</FormItem>
			)}
		/>
	);
};
